import React from 'react';

const Contact = ({ contactSection, styles = {} }) => {
  const { infoContainer, planeContact, contactAppFigure, contactAppLinks } = contactSection

  return (
    <section className="index-contact" id="index-contact">
      <picture>
        <source
          media="(min-width: 769px)"
          srcSet={infoContainer.bgImgWebP}
          type="image/webp"
        />
        <source media="(max-width: 768px)" srcSet="data:image/gif;base64,01" type="image/gif" />
        <img
          className="index-contact-bg lazyloaded"
          data-src={infoContainer.bgImgPng}
          alt={infoContainer.alt}
          src={infoContainer.bgImgPng}
          loading="lazy"
        />
      </picture>
      <div className="index-contact-inner container-block">
        <div className="index-contact-info">
          <h2 className="index-contact-heading" children={infoContainer.heading}/>
          <p className="index-contact-text" children={infoContainer.text}/>
          <a
            className="index-contact-mail-link"
            href={`mailto:${infoContainer.contactEmailLink}`}
            children={infoContainer.contactEmailLink}
          />
          <h3 className="index-contact-follow" children={infoContainer.indexContactFollow}/>
          <div>
            <a href={infoContainer.linkTwitter} className="index-contact-follow-link"
              aria-label="Follow us on Twitter"
              target="_blank"
            >
              <svg width="40px" height="40px" className="svg-sprite index-contact-follow-link-icon">
                <use href={infoContainer.hrefTwitter}/>
              </svg>
            </a>
            <a
              href={infoContainer.linkFb}
              className="index-contact-follow-link"
              aria-label="Follow us on Facebook"
              target="_blank"
            >
              <svg width="40px" height="40px" className="svg-sprite index-contact-follow-link-icon">
                <use href={infoContainer.hrefFb}/>
              </svg>
            </a>
            <a
              href={infoContainer.linkYT}
              className="index-contact-follow-link"
              aria-label="Follow us on Youtube"
              target="_blank"
            >
              <svg width="40px" height="40px" className="svg-sprite index-contact-follow-link-icon">
                <use href={infoContainer.hrefYT}/>
              </svg>
            </a>
          </div>
          <figure className={`index-airplate-contact ${styles.heliContact}`}>
            <picture>
              <source srcSet={planeContact.planeImgWebP} media="(min-width: 521px)"
                type="image/webp"
              />
              <source srcSet={planeContact.planeImgPng} media="(min-width: 521px)"
                type="image/png"
              />
              <source media="(max-width: 520px)" srcSet="data:image/gif;base64,01" type="image/gif" />
              <img
                data-src={planeContact.planeImgPng}
                alt={planeContact.planeAlt}
                className="lazyloaded"
                src={planeContact.planeImgPng}
                loading="lazy"
              />
            </picture>
          </figure>
        </div>
        {contactAppFigure.phonePinkImg && (
          <div className="index-contact-app">
            <div className="index-contact-app-links">
              <a
                className="app-link"
                href={contactAppLinks.iosLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <picture>
                  <source srcSet={contactAppLinks.iosHref} type="image/png" />
                  <img
                    src={contactAppLinks.iosHref}
                    alt={contactAppLinks.iosTitle}
                    title={contactAppLinks.iosTitle}
                  />
                </picture>
              </a>
              <a
                className="app-link"
                href={contactAppLinks.androidLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <picture>
                  <source
                    srcSet={contactAppLinks.androidHref}
                    type="image/png"
                  />
                  <img
                    className="app-link-img-android"
                    src={contactAppLinks.androidHref}
                    alt={contactAppLinks.androidTitle}
                    title={contactAppLinks.androidTitle}
                    height="54px"
                    width="166px"
                  />
                </picture>
              </a>
            </div>
            <figure className="index-contact-app-figure">
              <picture>
                <source
                  media="(min-width: 901px)"
                  srcSet={contactAppFigure.phonePinkImg}
                  type="image/png"
                />
                <source
                  media="(max-width: 900px)"
                  srcSet="data:image/gif;base64,01"
                  type="image/gif"
                />
                <img
                  data-src={contactAppFigure.phonePinkImg}
                  alt={contactAppFigure.phoneAlt}
                  className="index-contact-app-figure-bg lazyloaded"
                  src={contactAppFigure.phonePinkImg}
                  loading="lazy"
                />
              </picture>
              <picture>
                <source
                  media="(min-width: 901px)"
                  srcSet={contactAppFigure.appScreenImg}
                  type="image/png"
                />
                <source
                  media="(max-width: 900px)"
                  srcSet="data:image/gif;base64,01"
                  type="image/gif"
                />
                <img
                  className="index-contact-app-figure-inner lazyloaded"
                  data-src={contactAppFigure.appScreenImg}
                  alt={contactAppFigure.appAlt}
                  title={contactAppFigure.appAlt}
                  src={contactAppFigure.appScreenImg}
                />
              </picture>
            </figure>
          </div>
        )}
      </div>
    </section>
  );
};

export default Contact;
